
import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';

const SELECTOR_DIV = '.js-court-booking__wrapper';

const ELEMENT_SCROLL_SPACE_FROM_TOP = '180';
class CourtBooking {
	constructor() {
		this._data = {};
		this._sessionSelectedClasses = [];
		this.init();
	}

	init() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_DIV);
		if (!this._wrapper) {
			return;
		}

		const errorWrapper =  SelectorEngine.findOne('.p-expired-basket--error', this._wrapper);

		const errorCloseCta = SelectorEngine.findOne('.js-dismiss-expired-basket-error', this._wrapper);
		if(errorCloseCta){
			EventHandler.on(errorCloseCta, 'click', () => {
				errorWrapper.classList.add('u-hidden');
			});
		}
		if(errorWrapper){
			const linkCta = SelectorEngine.findOne('a', errorWrapper);
			EventHandler.on(linkCta, 'click', () => {
				const locationInputElements =  SelectorEngine.find('.js-location-search-field-input');
				const locationInputElement = locationInputElements.find( (inputElement) => this.isVisible(inputElement) );
				if(locationInputElement){
					const scrollDivTop = locationInputElement.parentElement.offsetTop;
					window.scrollTo({ top: scrollDivTop - ELEMENT_SCROLL_SPACE_FROM_TOP, behavior: 'smooth'});
					locationInputElement.focus();
				}
			});
		}
	}

	isVisible (element) {
		const { top, bottom } = element.getBoundingClientRect();
		const viewHeight = (window.innerHeight || document.documentElement.clientHeight);
		return (
			(top > 0 || bottom > 0) && top < viewHeight);
	}
}

const globalCourtBooking = new CourtBooking();
export default globalCourtBooking;
